/**
 * Single shared config for Google Maps JS API loading.
 * All loaders (useJsApiLoader, LoadScript, @googlemaps/js-api-loader) must use
 * this id and libraries so the script is loaded only once.
 */
export const GOOGLE_MAPS_SCRIPT_ID = "__googleMapsScriptId";

/** Same array reference everywhere so loaders reuse the same script. */
export const GOOGLE_MAPS_LIBRARIES = ["places"];
